import type { PortalClientDto } from '@supply-mover-2-0/shared';
import { clientDisplayId } from './clientDisplayId';

/**
 * Case-insensitive, multi-term match of a client against a search query.
 * The haystack covers every field the customer sees on an account card —
 * name, street address, city/state/zip, and the customer-facing ID — so
 * customers with access to a large number of accounts can find one by any
 * of those without scrolling the full list. (PD-14244)
 *
 * Multi-term: each whitespace-separated term must appear somewhere in the
 * haystack (order-independent), so "ace sioux" matches an account named
 * "ACE (Sioux Falls Food Co+op)". An empty query matches everything.
 */
export function clientMatchesSearch(
	client: PortalClientDto,
	query: string,
): boolean {
	const terms = query
		.trim()
		.toLowerCase()
		.split(/\s+/)
		.filter((term) => term !== '');
	if (terms.length === 0) {
		return true;
	}

	const haystack = [
		client.name,
		client.address1,
		client.address2,
		client.city,
		client.state,
		client.zip,
		clientDisplayId(client),
	]
		.filter((value): value is string => value != null && value !== '')
		.join(' ')
		.toLowerCase();

	return terms.every((term) => haystack.includes(term));
}
